import { render, staticRenderFns } from "./OhDearBadge.vue?vue&type=template&id=4ff9c8c6"
import script from "./OhDearBadge.vue?vue&type=script&lang=js"
export * from "./OhDearBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports